<template>
    <div>
        
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-md-2">

                    <MenuPacote></MenuPacote>

                </div>

                <div class="col-lg-9 col-md-10">

                    <ConjuntosMenu></ConjuntosMenu>

                    <div class="panel">
                        <div class="panel-header">
                            
                            <div class="row">
                                <div class="col-lg-8 col-md-8" style="padding-top:5px;">
                                    Autorizações
                                </div>
                                <div class="col-lg-4 col-md-4">
                                    <div class="row">
                                        <div class="col-4">
                                            <input type="text" class="form-control" placeholder="Nº AET">
                                        </div>
                                        <div class="col-4">
                                            <select class="form-control" v-model="orgao_id">
                                                <option value="" disabled>Orgão</option>
                                                <option v-for="orgao in orgaos" v-bind:key="orgao.id" :value="orgao.id">{{orgao.nome}}</option>
                                            </select>
                                        </div>
                                        <div class="col-4">
                                            <button class="btn-sm btn-success w-100" @click="ColocarEmFila(orgao_id)">Salvar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                            
                        <table class="table" style="margin-bottom:0px;">
                            <tbody>
                                <tr v-for="pedido in aets" v-bind:key="pedido.id">
                                    <td style="padding-top:20px;padding-left:15px;font-weight:bold;">
                                        <input type="checkbox" >
                                    </td>
                                    <td style="padding-top:15px;padding-left:10px;font-weight:bold;">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" :id="'customSwitch-'+pedido.id" v-model="pedido.relatorio" @change="UpRelatorio(pedido.relatorio, pedido.id)">
                                            <label class="custom-control-label" :for="'customSwitch-'+pedido.id"></label>
                                        </div>
                                    </td>
                                    <td style="padding-top:15px;padding-left:0px;font-weight:bold;">
                                        <button class="btn-sm btn-dark w-100" style="font-size:9pt;font-weight:500;" data-toggle="modal" data-target="#aet" @click="CarregarPedido(pedido)">{{pedido.id}}</button>
                                    </td>
                                    <td style="padding-top:15px;padding-left:0px;font-weight:bold;">

                                        <button v-if="pedido.aet" class="btn-sm btn-warning" style="font-size:9pt;margin-right:10px;" @click="VerArquivo(pedido.aet.arquivo)">
                                             <download-icon size="1.5x"></download-icon>
                                        </button>

                                        <button v-if="pedido.boleto" class="btn-sm btn-warning" style="font-size:9pt;" @click="VerArquivo(pedido.boleto.arquivo)">
                                             <dollar-sign-icon size="1.5x"></dollar-sign-icon>
                                        </button>
                                         
                                    </td>
                                    
                                    <td style="padding-top:15px;padding-left:25px;font-weight:bold;">{{pedido.orgao[0].nome}}</td>
                                    <td style="padding-top:15px">{{pedido._created_at}}</td>
                                    <td style="padding-top:15px"><span class="badge badge-success" style="font-weight:500;font-size:10pt;">{{pedido.numero_aet}}</span></td>
                                    <td style="padding-top:15px">{{pedido.resultado}}</td>
                                    <td style="padding-top:15px">
                                        {{statusStart(pedido)}}
                                    </td>
                                    <td style="padding-right:25px;" class="right">

                                       
                                        <a v-if="pedido.orgao[0].nome=='SP'" style="margin-left:15px;" :href="config.API+'imprimir/sp/'+pedido.carga_id" target="_blank" class="btn-sm btn-success">Autorização</a>
                                        <a v-if="pedido.orgao[0].nome=='SP'" style="margin-left:15px;" :href="config.API+'imprimir/crlvs/'+pedido.carga_id" target="_blank" class="btn-sm btn-success">CRLVs</a>
                                        <a v-if="pedido.orgao[0].nome=='SP'" style="margin-left:15px;" :href="config.API+'imprimir/desenho/'+pedido.carga_id" target="_blank" class="btn-sm btn-success">Desenho</a>

                                        <span  v-if="pedido.orgao[0].nome!='SP'">
                                            <button v-if="pedido.resumo"
                                            class="btn-sm btn-success" 
                                            style="margin-left:15px;" 
                                            @click="VerArquivo(pedido.resumo.arquivo)">Resumo </button>

                                            <button v-if="isPause(pedido.status, pedido.start)==false" class="btn-sm btn-danger" style="margin-left:15px;"  @click="Pausar(pedido.id)" :disabled="isPause(pedido.status, pedido.start)">Pausar</button>
                                            <button v-if="isStart(pedido.status, pedido.start)==false" class="btn-sm btn-dark" style="margin-left:15px;" @click="Executar(pedido.id)" :disabled="isStart(pedido.status, pedido.start)">Executar</button>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                            
                    </div>

                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="aet" tabindex="-1" role="dialog" aria-labelledby="aet" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Autorização {{epedido.id}} ({{epedido.orgao[0].nome}})</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row" style="margin-bottom:25px;">
                    <div class="col-lg-3 col-md-4">
                        <label style="font-size:11pt;">Nº do pedido</label>
                        <input type="text" class="form-control" style="padding:8px;height:34px;">
                    </div>
                    <div class="col-lg-3 col-md-4">
                        <label style="font-size:11pt;">Nº de AET</label>
                        <input type="text" class="form-control" style="padding:8px;height:34px;" v-model="epedido.numero_aet">
                    </div>
                    <div class="col-lg-6 col-md-4">
                        <label style="font-size:11pt;">Observações</label>
                        <input type="text" class="form-control" style="padding:8px;height:34px;" v-model="epedido.observacoes">
                    </div>
                </div>

                <div class="row">

                    <div class="col-lg-12 col-md-12">
                        <arquivos style="margin-top:15px;margin-bottom:25px;"
                        name="Autorização" 
                        ext="aet" 
                        :id="epedido.id" 
                        :multiple="false" 
                        :limit="1" />
                    </div>

                    <div class="col-lg-12 col-md-12">
                        <arquivos style="margin-top:15px;margin-bottom:25px;"
                        name="Protocolo" 
                        ext="aet_protocolo" 
                        :id="epedido.id" 
                        :multiple="false" 
                        :limit="1" />
                    </div>

                    <div class="col-lg-12 col-md-12">
                        <arquivos style="margin-top:15px;margin-bottom:25px;"
                        name="Boleto" 
                        ext="boleto" 
                        :id="epedido.id" 
                        :multiple="false" 
                        :limit="1" />
                    </div>

                </div>


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" @click="SalvarPedido()">Salvar</button>
            </div>
            </div>
        </div>
        </div>

    </div>
    
</template>

<script>
import MenuPacote from '@/modules/super/pages/MenuPacote'
import config from '@/config'
import ConjuntosMenu from '@/modules/super/pages/menus/conjunto-menu'
import arquivos from '@/components/arquivos'
import { DownloadIcon, DollarSignIcon  } from 'vue-feather-icons'

export default {
    name:"Autorizacoes",
    components:{
        MenuPacote, ConjuntosMenu, arquivos, DownloadIcon, DollarSignIcon
    },
    data(){
        return{
            config:config,
            carga_id:null,
            orgao_id:'',
            aets:{},
            orgaos:{},
            epedido:{
                orgao:{
                    0:{
                        nome:''
                    }
                }
            }
        }
    },
    methods:{
        ListarOrgaos(){
            this.$http.get(this.config.API+'orgaos')
            .then((response) => {
                this.orgaos = response.data.data;
            });
        },
        ColocarEmFila(id){
            this.$http.post(this.config.API+"fila/criar",{
                carga_id: this.carga_id,
                organ_id: id,
                numero_aet: '',
                situacao: 0,
                resultado: '',
                status: 0,
                start: 0
            })
            .then(res => {
                if(res.data.error==false){
                    this.Listar()
                }
            })
        },
        Executar(id){
            this.$http.put(this.config.API+'fila/editar/'+id,{
                carga_id:this.carga_id,
                start:1
            })
            .then(res => {
                console.log(res.data)
                this.Listar()
            })
        },
        Pausar(id){
            this.$http.put(this.config.API+'fila/editar/'+id,{
                carga_id:this.carga_id,
                start:0
            })
            .then(res => {
                console.log(res.data)
                this.Listar()
            })
        },
        Listar(){
            this.$http.get(this.config.API+'fila/ver/'+this.carga_id)
            .then(res => {
                this.aets = res.data.data
            })
        },
        isPause(status, start){
            if(status==0 && start==1){
                return false
            }else{
                return true
            }
        },
        isStart(status, start){
            if(status==1){
                return true
            }
            if(start==1){
                return true
            }
            return false
        },
        statusStart(pedido){
            if(pedido.status==1){
                return 'Cadastrada'
            }
            if(pedido.status==0 && pedido.start==0){
                return 'Pausada'
            }
            if(pedido.status==0 && pedido.start==1){
                return 'Em execução'
            }
        },

        VerArquivo(name){

            window.open(this.config.AWSS3+name, 'name=teste','width=800,height=800');

        },

        CarregarPedido(pedido){
            this.epedido = pedido
        },

        SalvarPedido(){
            this.$http.put(this.config.API+'fila/editar/'+this.epedido.id,{
                carga_id:this.carga_id,
                numero_aet: this.epedido.numero_aet,
                observacoes: this.epedido.observacoes
            })
            .then(res => {
                console.log(res.data)
                this.Listar()
            })
        },

        UpRelatorio(n, id){
            this.$http.put(this.config.API+'fila/editar/'+id,{
                carga_id:this.carga_id,
                relatorio:n
            })
            .then(res => {
                console.log(res.data)
                this.Listar()
            })
        }


    },
    beforeMount(){
        this.carga_id = this.$route.params.carga
        this.Listar()
        this.ListarOrgaos()
    }
}
</script>

<style scoped>
    .form-control{
        padding:5px;
        height: 29px;
        margin-bottom: 0px;
    }
</style>